import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Stack } from '@mui/material';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, EditButton, SubmitButton } from '../../../../../components/mui/Buttons/Buttons';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { changeTutorStatus, getInactiveReasons, getTrainerData } from '../../../../../redux/features/CRDslice';
import { useSnackbar } from 'notistack';

const statusTypes = [
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
  { id: 2, name: 'Temporary Inactive' },
];
// onChanged (optional): called after a successful change - the retention workspace's Tutor mapping stage reloads its
// own data with it. renderTrigger (optional): (open) => the button that opens the dialog, for a screen with its own look.
// The admission register page passes neither.
const TrainerStatusInactive = ({ activeType, row, dispatchParams, crm, onChanged, renderTrigger }) => {
  const [open, setOpen] = useState(false);
  const [inActiveType, setInActiveType] = useState(activeType ? activeType : 0);
  const [reasonId, setReasonId] = useState(row.trainer_unmap_reason_id);
  const { loading, inactiveReasons } = useSelector((store) => store.crd);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (open) {
      setInActiveType(activeType);
      setReasonId(row.trainer_unmap_reason_id);
      dispatch(getInactiveReasons());
    }
  }, [open]);

  const handleStatusChange = (event) => {
    setInActiveType(event.target.value);
  };
  const handleReasonChange = (event) => {
    setReasonId(event.target.value);
  };
  const handleCancel = () => {
    setOpen(false);
    setInActiveType(activeType);
    setReasonId(row.trainer_unmap_reason_id);
  };

  const handleSubmit = () => {
    // if ((activeType == 0 || activeType == 2) && !reasonId) {
    //   return
    // }
    // Inactive / Temporary Inactive need a reason - stop here, don't send the change without one
    if ((inActiveType == 0 || inActiveType == 2) && !reasonId) {
      enqueueSnackbar('Please select a reason for this status change', {
        variant: 'error',
      });
      return;
    }
    const data = {
      trainer_id: row.trainer_id,
      mapped_project: row.mapping_status,
      status: inActiveType,
      reason_id: reasonId,
      subjectEnrollmentId: row.subject_enrollment_id,
      trainer_assignment_id: row.trainer_assignment_id,
    };
    dispatch(changeTutorStatus(data)).then((res) => {
      if (res.payload.status === 'error') {
        enqueueSnackbar(res.payload.message, {
          variant: 'error',
        });
      } else if (res.payload.status === 'success') {
        handleCancel();
        dispatch(getTrainerData(dispatchParams));
        onChanged?.();
        enqueueSnackbar(res.payload.message, {
          variant: 'success',
        });
      }
    });
  };

  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Action'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        renderTrigger ? (
          renderTrigger(() => setOpen(true))
        ) : (
          <>
            <EditButton disabled={crm} action={() => setOpen(true)}>
              Change Status
            </EditButton>
          </>
        )
      }
      content={
        <>
          {open ? (
            <Box>
              <Box>
                <Stack gap={2}>
                  <FormControl fullWidth required>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                      placeholder="Select Status"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={inActiveType}
                      label="Status"
                      onChange={handleStatusChange}
                    >
                      {statusTypes.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {((inActiveType !== '' && inActiveType == 2) || inActiveType == 0) && (
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                      <InputLabel htmlFor="grouped-select">Reason</InputLabel>
                      <Select id="grouped-select" label="Reason" value={reasonId} onChange={handleReasonChange}>
                        <ListSubheader>General Reasons</ListSubheader>
                        {inactiveReasons
                          .filter((item) => item.trainer_unmap_requested_by == 0)
                          .map((item) => (
                            <MenuItem key={item.trainer_unmap_requested_by} value={item.trainer_unmap_reason_id}>
                              {item.trainer_unmap_reason}
                            </MenuItem>
                          ))}
                        <ListSubheader>Parent Reasons</ListSubheader>
                        {inactiveReasons
                          .filter((item) => item.trainer_unmap_requested_by == 1)
                          .map((item) => (
                            <MenuItem key={item.trainer_unmap_requested_by} value={item.trainer_unmap_reason_id}>
                              {item.trainer_unmap_reason}
                            </MenuItem>
                          ))}
                        <ListSubheader>Tutor Reasons</ListSubheader>
                        {inactiveReasons
                          .filter((item) => item.trainer_unmap_requested_by == 2)
                          .map((item) => (
                            <MenuItem key={item.trainer_unmap_requested_by} value={item.trainer_unmap_reason_id}>
                              {item.trainer_unmap_reason}
                            </MenuItem>
                          ))}
                      </Select>
                      {(inActiveType == 0 || inActiveType == 2) && !reasonId && (
                        <Box mt={1}>
                          <Alert severity="warning">Reason is required for this status change</Alert>
                        </Box>
                      )}
                    </FormControl>
                  )}
                </Stack>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Stack direction={'row'} spacing={1}>
                  <CancelButton action={() => handleCancel()}>Cancel</CancelButton>

                  <SubmitButton disabled={loading} type="submit" action={handleSubmit}>
                    {loading ? 'Submiting...' : 'Submit'}
                  </SubmitButton>
                </Stack>
              </Box>
            </Box>
          ) : null}
        </>
      }
    />
  );
};

export default TrainerStatusInactive;
